import axios from "axios";
import { authHeader } from "../authservice/auth-header";

const API_URL = process.env.VUE_APP_ROOT_API;

class IotDeviceService {
  getAllIotDeviceList() {
    return axios
      .get(API_URL + "iot-device/all-iot-device", { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }
}
export default new IotDeviceService();
